import React from 'react';
import { Row, Input } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Label, FormWrapper } from '../components';
import { useSectionActionPlan } from '../context';

export function Title() {
	const { form_field_name } = useSectionActionPlan();
	return (
		<Row>
			<Label>{I18n.get('Title')}</Label>
			<FormWrapper name={[...form_field_name, 'title']}>
				<Input placeholder={I18n.get('Title')} />
			</FormWrapper>
		</Row>
	);
}
